import { compareAsc, format, lastDayOfMonth, isAfter, add } from 'date-fns';
import { t } from 'src/i18n/config';

const toTC = {
  Monday: t('monday'),
  Tuesday: t('tuesday'),
  Wednesday: t('wednesday'),
  Thursday: t('thursday'),
  Friday: t('friday'),
  Saturday: t('saturday'),
  Sunday: t('sunday'),
};

const periodToTC = {
  morning: t('morning'),
  morning_afternoon: t('morningAfternoon'),
  afternoon: t('afternoon'),
  afternoon_evening: t('afternoonEvening'),
  evening: t('evening'),
  free: t('allDay'),
};

const periodToString = {
  morning: t('periodMorning'),
  morning_afternoon: t('periodMorningAfternoon'),
  afternoon: t('periodAfternoon'),
  afternoon_evening: t('periodAfternoonEvening'),
  evening: t('periodEvening'),
  free: t('periodAllDay'),
};

const periodToComparingValue = {
  上午: 0,
  早午診: 1,
  下午: 2,
  午晚診: 3,
  晚間: 4,
  全天: 5,
};

export const toPeriod = (date) => {
  const hr = parseInt(date.toTimeString().substring(0, 2), 10);
  if (hr > 0 && hr < 14) {
    return 'morning';
  }
  if (hr >= 14 && hr < 18) {
    return 'afternoon';
  }
  return 'evening';
};

export const PeriodToTC = (period) => {
  return periodToTC[period];
};

export const PeriodToString = (period) => {
  return periodToString[period];
};

export const toDayOfWeek = (date) => {
  return toDayOfWeekNumberOnly(date);
};

export const toDayOfWeekNumberOnly = (date) => {
  const day = format(date, 'iiii');
  return toTC[day];
};

export const toYear = (date) => {
  return format(date, 'y');
};

export const toMonth = (date) => {
  return date.getMonth() + 1;
};

export const toDay = (date) => {
  return date.getDate();
};

export const compare = (
  { date: xdate, time: xtime },
  { date: ydate, time: ytime }
) => {
  const datecomparing = compareAsc(xdate, ydate);
  if (datecomparing === 0) {
    return periodToComparingValue[xtime] - periodToComparingValue[ytime];
  }
  return datecomparing;
};
export const toFullDateString = (date) => {
  return `${toYear(date)} ${t('year')} ${toMonth(date)} ${t('month')} ${toDay(
    date
  )} ${t('day')} (${toDayOfWeekNumberOnly(date)})`;
};

export const toDisplayString = (date) => {
  return format(date, 'yyyy-MM-dd');
};

export const toTime = (date) => {
  return format(date, 'HH:mm');
};

export const getAllYears = (showRepublicYear) => {
  const nowyear = new Date().getFullYear();
  const allyears = [];
  for (let i = nowyear; i > 1911; i--) {
    const displayYear = showRepublicYear
      ? `${i - 1911} ${t('year')}`
      : `${i} ${t('year')}`;
    allyears.push({
      id: `${i}`,
      name: displayYear,
      value: `${i}`,
    });
  }
  return allyears;
};

export const getMonth = () => {
  const allmonth = [];
  for (let i = 1; i < 13; i++) {
    allmonth.push({
      id: `${i}`,
      name: `${i} ${t('month')}`,
      value: `${i}`,
    });
  }
  return allmonth;
};

export const getDays = (d) => {
  const date = d || new Date();
  const lastday = lastDayOfMonth(date);
  const lastdaynumber = lastday.getDate();
  const alldays = [];
  for (let i = 1; i < lastdaynumber + 1; i++) {
    alldays.push({
      id: `${i}`,
      name: `${i} ${t('day')}`,
      value: `${i}`,
    });
  }
  return alldays;
};

export const isAfterMin = (date, min) => {
  return isAfter(
    new Date(),
    add(date, {
      minutes: min,
    })
  );
};

export const isValidDate = (d) => {
  return d instanceof Date && !isNaN(d);
};
